module.exports = __webpack_public_path__ + "media/images/flags/16/Sri-Lanka-563dd832ef6b1f98695addcc456bdfe2.png";